(() => {
  async function buildCartShareUrl() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Failed to fetch cart');

    const cart = await res.json();
    if (!cart.items || !cart.items.length) return null;

    const parts = cart.items.map((item) => `${item.variant_id}:${item.quantity}`);
    return `${window.location.origin}/cart/${parts.join(',')}`;
  }

  async function shareViaAPI(url) {
    if (!navigator.share) return;
    await navigator.share({
      title: 'Shared cart',
      text: 'Open this cart to make someone happy.',
      url
    });
  }

  async function copyToClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return;
    }
    const temp = document.createElement('input');
    temp.value = text;
    document.body.appendChild(temp);
    temp.select();
    document.execCommand('copy');
    document.body.removeChild(temp);
  }

  function isIOS() {
    return /iphone|ipad|ipod/i.test(navigator.userAgent);
  }

  function setCopyButtonState(btn, state) {
    if (!btn) return;
    if (state === 'copied') {
      btn.textContent = 'Copied';
      btn.classList.add('is-copied');
      setTimeout(() => {
        btn.textContent = 'Copy';
        btn.classList.remove('is-copied');
      }, 2000);
    } else {
      btn.textContent = 'Copy';
      btn.classList.remove('is-copied');
    }
  }

  function getWrapper(el) {
    return el ? el.closest('.liss-share-wrapper') : null;
  }

  function getTooltip(wrapper) {
    // поддерживаем оба варианта разметки
    return wrapper
      ? wrapper.querySelector('[data-liss-gift-tooltip], [data-liss-gift-help]')
      : null;
  }

  function closeAllTooltips(exceptWrapper = null) {
    document
      .querySelectorAll('[data-liss-gift-tooltip], [data-liss-gift-help]')
      .forEach((el) => {
        const w = getWrapper(el);
        if (exceptWrapper && w === exceptWrapper) return;
        el.hidden = true;
      });
  }

  // ВАЖНО: capture=true, чтобы стабильно перехватывать клики внутри <summary>/<details>
  document.addEventListener(
    'click',
    async (e) => {
      const learnMoreBtn = e.target.closest('[data-liss-gift-learn]');
      const copyBtn = e.target.closest('[data-liss-cart-share-copy]');
      const shareTrigger = e.target.closest('[data-liss-cart-share]');
      const inputEl = e.target.closest('[data-liss-cart-share-input]');

      /* -----------------------------
         1) Learn more (ТОП приоритет)
      ------------------------------ */
      if (learnMoreBtn) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const wrapper = getWrapper(learnMoreBtn);
        const tooltip = getTooltip(wrapper);

        if (tooltip) {
          // закрываем остальные, чтобы не было нескольких открытых
          closeAllTooltips(wrapper);
          tooltip.hidden = !tooltip.hidden;
        }
        return;
      }

      /* -----------------------------
         2) Закрыть тултип кликом "вне"
      ------------------------------ */
      // Если клик не внутри тултипа и не по Learn more — закрываем все тултипы
      const clickedInsideTooltip = e.target.closest('[data-liss-gift-tooltip], [data-liss-gift-help]');
      const clickedLearn = e.target.closest('[data-liss-gift-learn]');
      if (!clickedInsideTooltip && !clickedLearn) {
        closeAllTooltips();
      }

      /* -----------------------------
         3) Copy button
      ------------------------------ */
      if (copyBtn) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const wrapper = getWrapper(copyBtn);
        const input = wrapper?.querySelector('[data-liss-cart-share-input]');
        const url = input?.value;

        if (!url) return;

        try {
          await copyToClipboard(url);
          setCopyButtonState(copyBtn, 'copied');
        } catch (err) {
          console.error(err);
        }
        return;
      }

      /* -----------------------------
         4) iOS share sheet ТОЛЬКО по клику на input
      ------------------------------ */
      if (inputEl) {
        const wrapper = getWrapper(inputEl);
        if (!wrapper) return;

        try {
          // если инпут пустой — сгенерим ссылку прямо сейчас
          if (!inputEl.value) {
            const url = await buildCartShareUrl();
            if (url) inputEl.value = url;
          }

          if (isIOS() && navigator.share && inputEl.value) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            await shareViaAPI(inputEl.value);
          }
        } catch (err) {
          console.error(err);
        }
        return;
      }

      /* -----------------------------
         5) Tap по строке (summary): только генерим ссылку и показываем UI
            (НЕ открываем share sheet на iOS)
      ------------------------------ */
      if (shareTrigger) {
        const wrapper = getWrapper(shareTrigger);
        if (!wrapper) return;

        try {
          const url = await buildCartShareUrl();
          if (!url) return;

          const input = wrapper.querySelector('[data-liss-cart-share-input]');
          if (input) input.value = url;
        } catch (err) {
          console.error(err);
        }
      }
    },
    true
  );

  // (опционально) закрывать тултип по Esc
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAllTooltips();
  });
})();
